<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer005">
<p class="OT" id="_idParaDest-3"><a id="_idTextAnchor002"></a><a href="#/Thiselton_A_Shorter_Guide2#toc2">Abbreviations</a></p>
<p class="AB"><em class="italic CharOverride-2">ANF	Ante-­­Nicene Fathers</em></p>
<p class="AB"><span class="CharOverride-2">BDAG	W. Bauer, F. W. Danker, W. F. Arndt, and F. W. Gingrich, </span><em class="italic CharOverride-2">A Greek–English Lexicon of the New Testament and Other Early Christian Literature, </em><span class="CharOverride-2">3rd ed. (Chicago: University of Chicago Press, 2003)</span></p>
<p class="AB"><span class="CharOverride-2">EKKNT	Evangelisch-­katholischer Kommentar zum Neuen Testament</span></p>
<p class="AB"><span class="CharOverride-2">HR	E. Hatch and H. A. Redpath, </span><em class="italic CharOverride-2">A Concordance to the Septuagint,</em><span class="CharOverride-2"> 2nd ed. (Grand Rapids: Baker Academic, 1998)</span></p>
<p class="AB"><span class="CharOverride-2">ICC	International Critical Commentary</span></p>
<p class="AB"><em class="italic CharOverride-2">JBL	Journal of Biblical Literature</em></p>
<p class="AB"><em class="italic CharOverride-2">JPT	Journal of Pentecostal Theology</em></p>
<p class="AB"><span class="CharOverride-2">JPTSup	Journal of Pentecostal Theology Supplement Series</span></p>
<p class="AB"><em class="italic CharOverride-2">JSNT	Journal for the Study of the New Testament</em></p>
<p class="AB"><em class="italic CharOverride-2">JTS	Journal of Theological Studies</em></p>
<p class="AB"><span class="CharOverride-2">LCC	Library of Christian Classics</span></p>
<p class="AB"><span class="CharOverride-2">NCB	New Century Bible</span></p>
<p class="AB"><span class="CharOverride-2">NICNT	New International Commentary on the New Testament</span></p>
<p class="AB"><em class="italic CharOverride-2">NIDB	New Interpreter’s Dictionary of the Bible</em></p>
<p class="AB"><em class="italic CharOverride-2">NIDOTTE	New International Dictionary of Old Testament Theology and Exegesis</em></p>
<p class="AB"><em class="italic CharOverride-2">NIDPCM	New International Dictionary of Pentecostal and Charismatic Movements</em></p>
<p class="AB"><span class="CharOverride-2">NIGTC	New International Greek Testament Commentary</span></p>
<p class="AB"><em class="italic CharOverride-2">NPNF	Nicene and Post-­­Nicene Fathers</em></p>
<p class="AB"><em class="italic CharOverride-2">NTS	New Testament Studies</em></p>
<p class="AB"><em class="italic CharOverride-2">PG	Patrologia Graeca, </em><span class="CharOverride-2">ed. J-P. Migne</span></p>
<p class="AB"><em class="italic CharOverride-2">PL	Patrologia Latina, </em><span class="CharOverride-2">ed. J-P. Migne</span></p>
<p class="AB"><span class="CharOverride-2">SBLDS	Society of Biblical Literature Dissertation Series</span></p>
<p class="AB"><span class="CharOverride-2">SBT	Studies in Biblical Theology</span></p>
<p class="AB"><em class="italic CharOverride-2">SJT	Scottish Journal of Theology</em></p>
<p class="AB"><span class="CharOverride-2">SNTSM	Studiorum Novi Testamenti Societas Monographs</span></p>
<p class="AB"><em class="italic CharOverride-2">TDNT	Theological Dictionary of the New Testament</em></p>
<p class="AB"><em class="italic CharOverride-2">TDOT	Theological Dictionary of the Old Testament</em></p>
<p class="AB"><span class="CharOverride-2">WUNT	Wissenschaftliche Untersuchungen zum Neuen Testament</span></p>
<p class="AB"><span class="CharOverride-2">WUNT/2	Wissenschaftliche Untersuchungen zum Neuen Testament, 2. Reihe</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Thiselton_A_Shorter_Guide-4.vue?6fe07759